import { Controller } from "@hotwired/stimulus"

// installment-scope — ao salvar uma PARCELA cujo valor mudou, intercepta o submit
// e abre um modal perguntando o alcance da mudança (todas / esta e futuras / esta
// e anteriores / só esta). A escolha vai num hidden field (installment_scope) e o
// form é submetido. Lançamento não-parcelado, ou valor intacto, submete direto.
//
// CSP-safe (sem handler inline). O modal é o componente ui :dialog padrão; abrimos
// programaticamente disparando um clique num trigger oculto (o dialog escuta
// data-dialog-trigger via delegação no document).
//
// Uso: no <form>, data-controller="installment-scope"
//   data-action="submit->installment-scope#maybeConfirm"
//   data-installment-scope-installment-value="true|false"
//   data-installment-scope-original-cents-value="29309"
//   data-installment-scope-dialog-id-value="reprice-dialog"
// Targets: amountInput (o input de valor), scopeField (hidden), dialogTrigger
//   (elemento oculto com data-dialog-trigger=<dialog-id>).
export default class extends Controller {
  static targets = ["amountInput", "scopeField", "dialogTrigger"]
  static values = {
    installment: Boolean,
    originalCents: Number,
    dialogId: String
  }

  connect() {
    // Registramos o interceptor de submit na fase de CAPTURA para rodar ANTES do
    // listener de submit do mask_controller (que faz strip do valor para dígitos
    // crus). Assim, ao abrir o modal, paramos a propagação e o valor no input
    // permanece formatado atrás do modal. Ao confirmar (choose), removemos o
    // bloqueio e deixamos o submit seguir normalmente (mask faz o strip a tempo).
    this._boundIntercept = this._intercept.bind(this)
    this.element.addEventListener("submit", this._boundIntercept, true)
  }

  disconnect() {
    this.element.removeEventListener("submit", this._boundIntercept, true)
  }

  _intercept(event) {
    // Já confirmou no modal (choose): deixa este submit passar sem reabrir.
    if (this._confirmed) {
      this._confirmed = false
      return
    }

    // Não é parcela: deixa submeter normal (só edita este Entry).
    if (!this.installmentValue) return

    // Valor não mudou: nada a propagar, submete direto (só esta).
    if (this._currentCents() === this.originalCentsValue) return

    // Valor mudou numa parcela: bloqueia o submit (inclusive o strip do mask,
    // que escuta na fase de bubbling) e abre o modal de alcance.
    event.preventDefault()
    event.stopImmediatePropagation()
    if (this.hasDialogTriggerTarget) this.dialogTriggerTarget.click()
  }

  // Chamado pelos botões do modal: seta o alcance escolhido e submete o form.
  choose(event) {
    const scope = event.currentTarget.dataset.scope || "only_this"
    if (this.hasScopeFieldTarget) this.scopeFieldTarget.value = scope
    this._confirmed = true   // o próximo submit não reabre o modal
    this._submit()
  }

  _submit() {
    this.element.requestSubmit
      ? this.element.requestSubmit()
      : this.element.submit()
  }

  _currentCents() {
    if (!this.hasAmountInputTarget) return this.originalCentsValue
    const raw = this.amountInputTarget.value.replace(/[^\d]/g, "")
    return raw ? parseInt(raw, 10) : 0
  }
}
